import { getAuth } from "firebase/auth";
import { doc, getDoc, getFirestore, Timestamp } from "firebase/firestore";

export default async function getCurrentUserData(){

    try {

        const currentUserRef = doc(getFirestore(), 'users',getAuth()!.currentUser!.uid!)
        const snapShot = await getDoc(currentUserRef)


        if(snapShot.exists()){
            return {
                ...snapShot.data(),
                created_at: (new Timestamp(snapShot.data().created_at.seconds, snapShot.data().created_at.nanoseconds).toMillis())
            }
        }

        throw new Error("user_not_found")
        
    } catch (error) {
        throw error
    }
    
}